<template>
    <div class="widget-parameter-setup-summary">
        <div class="text-base font-semibold mb-1">
            {{ $t('widget.parameterSetup.summary.title') }}
        </div>
        <p class="text-main-xs text-gray-500 mb-4">
            {{ $t('widget.parameterSetup.summary.description') }}
        </p>

        <div class="space-y-3">
            <div
                v-for="item in items"
                :key="item.config.ParameterName"
                class="rounded-lg border border-secondary-actions px-3 py-2.5"
            >
                <div class="text-sm font-semibold mb-1 truncate">
                    {{ item.label }}
                </div>
                <component
                    :is="item.entry.summaryComponent"
                    :value="item.config"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
    getWizardParameterEntry,
    getWizardParameterLabel,
    getWizardParameters
} from '@/components/RedesignComponents/Widgets/widgetParameterRegistry'
import { WidgetConfig } from '@/types/dashboard'

const props = defineProps<{
    configs: Array<WidgetConfig>
}>()

const items = computed(() => {
    return getWizardParameters(props.configs).flatMap(config => {
        const entry = getWizardParameterEntry(config)
        return entry
            ? [ {
                config,
                entry,
                label: getWizardParameterLabel(config)
            } ]
            : []
    })
})
</script>
